import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { AlertsService } from '../../services/alerts/alerts.service';
import { InvestorType } from '../../enums/investor-type.enum';
import { AlertTypeEnum } from '../../enums/alert-type.enum';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Wakala Guard
 * Protects wakala route - user can only access if:
 * 1. User type is INDIVIDUAL
 * 2. Nafath gate is passed (complete_nafath)
 * 3. Minor proxy gate status is pending_submission
 *
 * Redirects to home if conditions are not met
 *
 * Usage in routes:
 * - Apply canActivate: [wakalaGuard] to wakala route
 */
export const wakalaGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const alertsService = inject(AlertsService);
  const router = inject(Router);

  // Get auth data for type check
  const authData = authService.authData();
  const userType = authData?.type;

  // Check conditions using gates
  const isIndividual = userType === InvestorType.INDIVIDUAL;
  const isNafathPassed = alertsService.isGatePassed(
    AlertTypeEnum.COMPLETE_NAFATH
  );
  const isProxyPending =
    alertsService.getGateStatus(AlertTypeEnum.MINOR_PROXY) ===
    'pending_submission';

  // If any condition fails, redirect to home
  if (!isIndividual || !isNafathPassed || !isProxyPending) {
    router.navigate([ROUTE_PATHS.HOME], {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
    return false;
  }

  return true;
};
